<template>
  <div>
    <v-btn
      :loading="loading"
      :disabled="loading"
      color="#2262c6"
      class="ma-2 white--text"
      @click="downloadPlantilla"
    >
      Descargar Plantilla

      <v-icon
        right
        dark
      >
        mdi-cloud-download
      </v-icon>

      <template v-slot:loader>
        <span>Descargando</span>
        <v-progress-circular
          indeterminate
          size="16"
          color="primary"
          class="ml-1"
        ></v-progress-circular>
      </template>
    </v-btn>
  </div>
</template>

<script>
import uris from '../../../utils/uris'
import axios from '../../../utils/axiosWrapperAutoservicio'
import userStorage from '../../../storage/userStorage'

export default {
  name: 'validation-header',
  data () {
    const user = userStorage.getUserInfo()
    return {
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN',
      loading: false
    }
  },
  props: {
    processID: {
      type: Number,
      default () {
        return 0
      }
    }
  },
  methods: {
    downloadPlantilla () {
      this.loading = true
      axios.post(uris.URL_AUTOSERVICIO_GET_TEMPLATE, {
        processID: this.processID
      }, {
        responseType: 'blob'
      })
        .then((response) => {
          const filename = response.headers.filename
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch((err) => {
          console.warn('No se ha podido obtener data del autoservicio', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/autoservicios/validation/validation-header.vue